// extracted by mini-css-extract-plugin
export var addViewLink = "_a-2";
export var availabilityIcon = "_a-17";
export var availabilitySelectionIcon = "_a-16";
export var backButton = "_a-3";
export var backIcon = "_a-10";
export var conversationCount = "_a-4";
export var dragHandle = "_a-6";
export var dropdown = "_a-f";
export var dropdownIcon = "_a-8";
export var dropdownOption = "_a-7";
export var dropdownTriangle = "_a-e";
export var expand = "_a-g";
export var folder = "_a-j";
export var folderItem = "_a-d";
export var icon = "_a-9";
export var iconRow = "_a-a";
export var image = "_a-b";
export var logo = "_a-c";
export var navContainer = "_a-i";
export var navigationFooter = "_a-h";
export var pageShell = "_a-0";
export var pageShellWms = "_a-1";
export var placeholderAvailable = "_a-12";
export var placeholderBox = "_a-15";
export var placeholderBusy = "_a-14";
export var placeholderUnavailable = "_a-13";
export var profile = "_a-l";
export var profileContainer = "_a-n";
export var profileDropdown = "_a-o";
export var profileImage = "_a-m";
export var profileMain = "_a-p";
export var profileSubtitle = "_a-r";
export var profileTitle = "_a-q";
export var reorderIcon = "_a-s";
export var sentLine = "_a-v";
export var settingsHeader = "_a-t";
export var sidenavTextColor = "_a-z";
export var spamLine = "_a-u";
export var subitemWithTag = "_a-5";
export var supportItems = "_a-k";
export var teamText = "_a-11";
export var viewLine = "_a-y";
export var viewLineButton = "_a-x";
export var viewLineButtons = "_a-w";